/**
 * Le **titre d'un contrôle** du prototype, le même aux deux fronts : le **numéro de dossier**,
 * celui que le client emploie, et la référence GHP seulement s'il manque (M1 : deux nullables).
 * `null` — la demande n'est pas encore lue — rend « Contrôle » nu ; `short`, le nom seul.
 */
export function inspectionTitle(inquiry, { short = false } = {}) {
    if (inquiry === null)
        return 'Contrôle';
    const name = inquiry.caseReference === null ? inquiry.reference : `#${inquiry.caseReference}`;
    if (name === null)
        return 'Contrôle sans référence';
    return short ? name : `Contrôle ${name}`;
}
//# sourceMappingURL=title.js.map